import useSWRMutation from 'swr/mutation';
import { useSWRAxiosMutation } from '../../useSWRAxiosMutation';
import { submitRegionFeedbackUrl } from 'constants/urls';
import { useUserContext } from 'context/UserContext';
import { DrawerFeedbackRequestBody } from './types';
import { useRegionContext } from 'context/RegionContext';

export const useSubmitFeedback = () => {
    const { user } = useUserContext();
    const { region } = useRegionContext();
    const url = submitRegionFeedbackUrl(user?.id ?? '', region?.id);
    const { post } = useSWRAxiosMutation();
    const submitFeebackRequest = (url: string, { arg }: { arg: DrawerFeedbackRequestBody }) => post(url, arg);
    const { trigger, isMutating, error } = useSWRMutation(url, submitFeebackRequest);

    return {
        submitFeedback: trigger,
        isMutating,
        error: error?.response?.data
    };
};
